import React from 'react'
import PropTypes from 'prop-types'
import Svg from '../shared/Svg'

const CrossIcon = ({
  width, height, fill, ...props
}) => (
  <Svg {...props} width={`${width}px`} height={`${height}px`} viewBox="0 0 14 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-934.000000, -113.000000)" fill={fill}>
        <g transform="translate(308.000000, 94.000000)">
          <g transform="translate(25.000000, 19.000000)">
            <g>
              <g transform="translate(599.000000, 0.000000)">
                <path
                  d="M7.22321846,6.63716383 L2.29262888,1.70657425 C1.90245704,1.31640241 1.90245704,0.683808861 2.29262888,0.293637017 C2.68280073,-0.0965348277 3.31539428,-0.0965348277 3.70556612,0.293637017 L8.65624507,5.24431596 L13.6079321,0.292628883 C13.998104,-0.0975429611 14.6306975,-0.0975429611 15.0208694,0.292628883 C15.4110412,0.682800728 15.4110412,1.31539428 15.0208694,1.70556612 L10.0923233,6.6341122 L15.0229129,11.5647018 C15.4130847,11.9548736 15.4130847,12.5874672 15.0229129,12.977639 C14.632741,13.3678109 14.0001475,13.3678109 13.6099756,12.977639 L8.6592967,8.02696007 L3.70760962,12.9786471 C3.31743777,13.368819 2.68484422,13.368819 2.29467238,12.9786471 C1.90450054,12.5884753 1.90450054,11.9558818 2.29467238,11.5657099 L7.22321846,6.63716383 Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Svg>
)

CrossIcon.defaultProps = {
  width: 14,
  height: 14,
  fill: '#4A4A4A',
}

CrossIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default CrossIcon
